import { message } from "antd";
import {
  deleteCustomActionsArray,
  postCustomActionsArray,
  putCustomActions,
  putCustomActionsArray,
} from "../service";

function useCustomActions({ syncAssistant, workspaceId, assistantId }) {
  const removeCustomAction = async (customActionId, lifecycleCbs) => {
    message.loading("Deleting trigger");
    lifecycleCbs.init();

    try {
      const response = await deleteCustomActionsArray({
        workspaceId,
        assistantId,
        customActionId,
      });

      if (response.status === 200) {
        message.destroy();
        message.success("Trigger deleted");
        lifecycleCbs.success();

        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customActions: {
              ...prevAssistant.customActions,
              customActionsArray: response.data,
            },
          };
        });

        return;
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to delete trigger"
      );
      lifecycleCbs.error(e);
    }
  };

  const toggleCustomAction = async (payload, lifecycleCbs) => {
    lifecycleCbs.init();
    try {
      const response = await putCustomActions({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        lifecycleCbs.success();
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customActions: response.data,
          };
        });
        return;
      }
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  const updateCustomAction = async (data, customActionId, lifecycleCbs) => {
    message.loading("Updating trigger");
    lifecycleCbs.init();
    try {
      const response = await putCustomActionsArray({
        workspaceId,
        assistantId,
        customActionId,
        payload: data,
      });

      if (response.status === 200) {
        message.destroy();
        message.success("Trigger updated");
        lifecycleCbs.success();
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customActions: {
              ...prevAssistant.customActions,
              customActionsArray: response.data,
            },
          };
        });
        return;
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update trigger"
      );
      lifecycleCbs.error(e);
    }
  };

  const createCustomAction = async (data, lifecycleCbs) => {
    message.loading("Adding trigger");
    lifecycleCbs.init();
    try {
      const response = await postCustomActionsArray({
        workspaceId,
        assistantId,
        payload: data,
      });

      if (response.status === 201) {
        message.destroy();
        message.success("Trigger added");
        lifecycleCbs.success();
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            customActions: {
              ...prevAssistant.customActions,
              customActionsArray: response.data,
            },
          };
        });
        return;
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to add trigger"
      );
      lifecycleCbs.error(e);
    }
  };

  return {
    removeCustomAction,
    updateCustomAction,
    createCustomAction,
    toggleCustomAction,
  };
}

export { useCustomActions };
